import React, { useContext, useRef, useState } from "react";
import "./Contact.css";
import emailjs from "@emailjs/browser";
import { themeContext } from "../../Context";
const Contact = () => {
  const [user_name,set_user_name]=useState ('');
  const [user_email,set_user_email]=useState ('');
  const [message,set_message]=useState ('');
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const form = useRef();
  const [done, setDone] = useState(false)
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_iur4uoj",
        "template_mfx698o",
        form.current,
        "DA0afRiR4zqCl8xrZ"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
          form.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  const handleName=(e)=>{
    set_user_name(e.target.value)
  }
  const handleEmail=(e)=>{
    set_user_name(e.target.value)
  }
  const handlemessage=(e)=>{
    set_message(e.target.value)
  }

  return (
    <div className="contact-form" id="contact">
      {/* left side copy and paste from work section */}
      <div className="w-left">
        <div className="awesome">
          {/* darkMode */}
          <span style={{color: darkMode?'white': ''}}>Get in Touch</span>
          <span>Contact me</span>
          <div
            className="blur s-blur1"
            style={{ background: "#ABF1FF94" }}
          ></div>
        </div>
      </div>
      {/* right side form */}
      <div className="c-right">
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="user_name" className="user" onChange={handleName}   placeholder="Name"/>
          <input type="email" name="user_email" className="user" onChange={handleEmail}  placeholder="Email"/>
          <textarea name="message" className="user" onChange={handlemessage} placeholder="Message"/>
          <input type="submit" value="Send" className="button"/>
          <span>{done && "Thanks for Contacting me"}</span>
          <div
            className="blur c-blur1"
            style={{ background: "var(--purple)" }}
          ></div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
